import { render, staticRenderFns } from "./hall.vue?vue&type=template&id=0cfcae08&scoped=true"
import script from "./hall.vue?vue&type=script&lang=js"
export * from "./hall.vue?vue&type=script&lang=js"
import style0 from "./hall.vue?vue&type=style&index=0&id=0cfcae08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfcae08",
  null
  
)

export default component.exports